import React, { useState } from 'react'
import AdminAppBody from '../../../../components/admin/AdminAppBody'

const SchoolCollegeRequest = () => {
 
  const [requests, setRequests] = useState([
    {
      id: 1,
      name: "ABC College",
      email: "contact@abccollege.edu",
      address: "123 Main St, Pune",
      contact: "9876543210",
      status: "Pending"
    },
    {
      id: 2,
      name: "XYZ Institute",
      email: "info@xyzinstitute.ac.in",
      address: "45 Second St, Mumbai",
      contact: "9123456780",
      status: "Pending"
    },
  ]);
  const [showModal, setShowModal] = useState(false);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [selectedReason, setSelectedReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  const reasons = [
    "Incomplete profile",
    "Lack of experience",
    "Not available",
    "Other",
  ];

  const handleAccept = (id) => {
    const updated = requests.map((req) =>
      req.id === id ? { ...req, status: "Accepted" } : req
    );
    setRequests(updated);
  };

  const handleRejectClick = (mentor) => {
    setSelectedMentor(mentor);
    setShowModal(true);
    setSelectedReason("");
    setCustomReason("");
  };

  const handleRejectSubmit = () => {
    const reasonToUse = customReason.trim() || selectedReason;

    if (!reasonToUse) {
      alert("Please select or enter a reason");
      return;
    }

    const updated = requests.map((req) =>
      req.id === selectedMentor.id
        ? { ...req, status: `Rejected - ${reasonToUse}` }
        : req
    );

    setRequests(updated);
    setShowModal(false);
    setSelectedMentor(null);
    setSelectedReason("");
    setCustomReason("");
  };

  // Close modal on background click or cancel
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMentor(null);
    setSelectedReason("");
    setCustomReason("");
  };

  return (
    <AdminAppBody
      content={
        <div className="container mt-5">
          <h2 className="mb-4">School/College Request List</h2>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="table-light">
                <tr>
                   <th>College Name</th>
                <th>Email</th>
                <th>Address</th>
                <th>Contact</th>
                <th>Status</th>
                <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {requests.map((requests) => (
 <tr key={requests.id}>
                  <td>{requests.name}</td>
                  <td>{requests.email}</td>
                  <td>{requests.address}</td>
                  <td>{requests.contact}</td>
                  <td>{requests.status}</td>


                 
                    <td>
                      {requests.status === "Pending" && (
                        <>
                          <button
                            className="btn  me-2"
                            onClick={() => handleAccept(requests.id)}
                          >
                            Accept
                          </button>
                          <button
                            className="btn "
                            onClick={() => handleRejectClick(requests)}
                          >
                            Reject
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Custom Modal */}
          {showModal && (
            <div
              className="modal d-block"
              tabIndex={-1}
              role="dialog"
             
              onClick={handleCloseModal}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
                onClick={(e) => e.stopPropagation()} // prevent modal close on inner click
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Reject Reason</h5>
                    <button
                      type="button"
                      className="btn-close"
                      aria-label="Close"
                      onClick={handleCloseModal}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <label htmlFor="reasonSelect" className="form-label">
                      Select a reason:
                    </label>
                    <select
                      id="reasonSelect"
                      className="form-select"
                      value={selectedReason}
                      onChange={(e) => setSelectedReason(e.target.value)}
                    >
                      <option value="">-- Select a reason --</option>
                      {reasons.map((reason, index) => (
                        <option key={index} value={reason}>
                          {reason}
                        </option>
                      ))}
                    </select>

                    <label className="form-label mt-3" htmlFor="customReasonInput">
                      Or enter custom reason:
                    </label>
                    <input
                      id="customReasonInput"
                      type="text"
                      className="form-control"
                      placeholder="Enter custom reason here"
                      value={customReason}
                      onChange={(e) => setCustomReason(e.target.value)}
                    />
                    <div className="form-text">
                      Custom reason will override the selected reason.
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCloseModal}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn"
                      onClick={handleRejectSubmit}
                    >
                      Reject
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      }
    />
  );
};

export default SchoolCollegeRequest;
